declare global {
  interface Window {
    __triggerBackEvent: () => void;
    gtag?: (...args: any[]) => void;
  }
}

import { GoogleAnalytics } from '~/google_analytics/events';

export default defineNuxtPlugin(() => {
  if (!process.client) return;

  const router = useRouter();

  let isHandlingBack = false;

  /**
   * ✅ Detect REAL browser back using Vue Router history listener
   * This only fires when direction === 'back'
   */
  if (router.options.history) {
    router.options.history.listen((_to, _from, info) => {
      if (info.direction === 'back') {
        triggerBackEvent('browser');
      }
    });
  }

  /**
   * ✅ Native mobile back (Android/iOS WebView)
   */
  window.addEventListener('message', (event: MessageEvent) => {
    if (event?.data?.type === 'back_pressed') {
      triggerBackEvent('phone');
    }
  });

  /**
   * ✅ Manual trigger support
   */
  window.__triggerBackEvent = () => {
    triggerBackEvent('phone');
  };

  /**
   * 🔒 Prevent duplicate firing
   */
  function triggerBackEvent(source: 'browser' | 'phone') {
    if (isHandlingBack) return;

    isHandlingBack = true;

    try {
      GoogleAnalytics.backButtonClick({
        source,
      });
      console.log('Back button event triggered:', source);
    } catch (error) {
      console.error('Error while sending back button event:', error);
    }

    // Small delay to prevent double fire (WebView safe)
    setTimeout(() => {
      isHandlingBack = false;
    }, 300);
  }
});
